import {
  BookOpenText,
  type Icon,
  IdentificationBadge,
  IdentificationCard,
  MapPin,
} from "@phosphor-icons/react";

import type { ConversationParticipant } from "common/types";

export const INBOX_VARIABLES: {
  icon: Icon;
  label: string;
  getValue: (profile: ConversationParticipant) => string;
}[] = [
  {
    icon: IdentificationBadge,
    label: "First Name",
    getValue: (profile) => profile.first_name,
  },
  {
    icon: IdentificationCard,
    label: "Last Name",
    getValue: (profile) => profile.last_name,
  },
  {
    icon: BookOpenText,
    label: "Occupation",
    getValue: (profile) => profile.occupation,
  },
  {
    icon: MapPin,
    label: "Location",
    getValue: (profile) => profile.location?.name,
  },
];

// List of supported mime types
export const MIME_TYPES = [
  // WAV format (most reliable for duration)
  { mimeType: "audio/wav", extension: "wav" },

  // MP4 formats (Safari, iOS) - better duration support
  { mimeType: "audio/mp4;codecs=mp4a.40.2", extension: "m4a" },
  { mimeType: "audio/mp4", extension: "m4a" },

  // OGG format (Firefox) - better than WebM for duration
  { mimeType: "audio/ogg;codecs=opus", extension: "ogg" },
  { mimeType: "audio/ogg;codecs=vorbis", extension: "ogg" },
  { mimeType: "audio/ogg", extension: "ogg" },

  // WebM formats (most widely supported but duration issues)
  { mimeType: "audio/webm;codecs=opus", extension: "webm" },
  { mimeType: "audio/webm;codecs=vorbis", extension: "webm" },
  { mimeType: "audio/webm", extension: "webm" },
];
